import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonIcon,
  FormHeader,
  InputBox,
  SectionHeader,
} from "../../../components";
import {
  closeProfileCreateModal,
  setAdsUserDetails,
} from "../../AdsPlatform/redux/actions";
import {
  CheckValidity,
  newsUserDetails,
  setAdsSession,
  setUserSession,
} from "../../../utils";
import { Progress } from "antd";
import { updateProfile } from "../../AdsSignUp/services/adsSignup.service";
import { Store } from "react-notifications-component";
import { setNewsUser } from "../../console/redux/actions";

const Index = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const { newsUser } = useSelector(({ consoleReducer }) => consoleReducer);

  const { isOpenProfileCreateModal } = useSelector(
    ({ adsUserReducer }) => adsUserReducer
  );

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    contactNo: {
      key: "contactNo",
      label: "Contact No",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "+94",
        maxLength: 12,
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    password: {
      key: "password",
      label: "Password",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "password",
        placeholder: "**********",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    confirmPassword: {
      key: "confirmPassword",
      label: "Confirm Password",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "password",
        placeholder: "**********",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const handleChange = async (event, inputIdentity) => {
    const updateProfileForm = {
      ...formData,
    };

    updateProfileForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateProfileForm[inputIdentity].value,
      updateProfileForm[inputIdentity].validation
    );

    if (validityRes) {
      updateProfileForm[inputIdentity].isValid = validityRes.isValid;
      updateProfileForm[inputIdentity].invalidReason = validityRes.reason;

      updateProfileForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateProfileForm) {
        formIsValid = updateProfileForm[inputIdentifier].valid && formIsValid;
      }
      if (
        inputIdentity === "confirmPassword" &&
        updateProfileForm["password"].value !==
          updateProfileForm["confirmPassword"].value
      ) {
        updateProfileForm["confirmPassword"].invalidReason =
          "Password not match.";
        formIsValid = false;
      }
      setFormData(updateProfileForm);
    }
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setFormData(updateForm);
  };

  const getOverallProgress = (currentStep) => {
    switch (currentStep) {
      case 1:
        return { percent: 30, status: "active" };
      case 2:
        return { percent: 60, status: "active" };
      case 3:
        return { percent: 100, status: "normal" }; // or "success"
      default:
        return { percent: 0, status: "exception" };
    }
  };

  const onClickDone = async () => {
    setIsLoading(true);

    console.log("new user", newsUser);

    const updateProfileForm = { ...formData };

    try {
      const body = {
        contact_no: updateProfileForm.contactNo.value,
        password: updateProfileForm.password.value,
      };

      const response = await updateProfile(newsUser?.company_id, body);

      console.log("Update Profile response:", response);
      setIsLoading(false);

      if (response?.data?.status) {
        Store.addNotification({
          title: "Success!",
          message: "Profile updated successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
        // page refresh
        window.location.reload();
        // props.history.push("/");
        setAdsSession(response.data.data?.token);

        dispatch(setAdsUserDetails(response.data.data?.user));
        if (response.data.data?.user?.company_type !== "publisher") {
          dispatch(setNewsUser(response.data.data?.user));
          setUserSession(response.data.data?.token);
        }
        dispatch(closeProfileCreateModal());
      } else {
        Store.addNotification({
          title: "Error!",
          message: response.data.message || "Failed to update profile.",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
      }
    } catch (error) {
      console.error("Error creating profile:", error);
      setIsLoading(false);
    }
  };

  // set a timer to automatically active resend button after 30 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDisable(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  useEffect(() => {
    let companyUser = newsUserDetails();
    if (companyUser?.company_id) {
      setUser(companyUser);
    }
  }, []);

  const fetchEmail = (value) => {
    return value.replace(
      /^[ ]*([^@\s])([^@\s]*)(@(?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i,
      (_, firstChar, rest, domain) =>
        `${firstChar}${"*".repeat(rest.length)}${domain}`
    );
  };

  const updateProfileForm = { ...formData };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenProfileCreateModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container d-flex flex-column w-400 animate__animated  ${
          isOpenProfileCreateModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeProfileCreateModal())}
          />
        </div>
        <div className={"evmp__form"}>
          <div className={"profile-wrapper"}>
            {/* <div>
              <TopMenu
                data={{
                  size: "sm",
                  isLanguage: false,
                  isLogo: false,
                  isProfile: false,
                }}
              />
            </div> */}
            <div className={"sw__main-wrp"}>
              <div className={"sw__nagivator"}>
                {/* <ButtonIcon
                  data={{
                    iconName: "h-wrrow-left",
                    size: "md",
                    type: "light",
                  }}
                  onClick={() => {
                    props.history.push("/");
                  }}
                />
                Back to home */}
              </div>
              <div className={"sw__form"}>
                <div className={"swf__header-wrapper"}>
                  <div className={"swf__hw-logo"}>
                    <img
                      src={require("../../../assets/img/lgo.png")}
                      alt={"logo"}
                    />
                  </div>
                  <FormHeader
                    data={{
                      formHeader: "Hi, " + newsUser?.company_name,
                      lan: "en",
                      size: "sm-md",
                    }}
                  />
                  <SectionHeader
                    data={{
                      title: "Please complete your profile",
                      lan: "en",
                      size: "xs-md",
                    }}
                  />

                  <Progress
                    // {...getOverallProgress(80)}
                    showInfo={false}
                    percent={80}
                    strokeColor=" #C40B4A"
                    trailColor=" #FA1C690A"
                  />
                </div>

                <InputBox
                  data={updateProfileForm.contactNo}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateProfileForm.contactNo.key
                    );
                  }}
                />
                <InputBox
                  data={updateProfileForm.password}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateProfileForm.password.key
                    );
                  }}
                />

                <InputBox
                  data={updateProfileForm.confirmPassword}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateProfileForm.confirmPassword.key
                    );
                  }}
                />

                <Button
                  data={{
                    btnName: "DONE",
                    buttonType:
                      updateProfileForm.contactNo.value === "" ||
                      updateProfileForm.password.value === "" ||
                      updateProfileForm.confirmPassword.value === ""
                        ? "primary disabled"
                        : "primary",
                    buttonSize: "lg",
                    isLoading: isLoading,
                    disable: isDisable,
                  }}
                  onClick={async (e) => {
                    e.preventDefault(e);
                    await onClickDone();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
